<template>
  <div class="home animated fadeIn" :style="home_height">
    <!-- <transition name='fade'
                enter-active-class='animated zoomOutLeft'
                leave-active-class='animated zoomOutRight'>
      <div v-if='show'>hello world</div>
    </transition> -->
    <img class="icon-singing" src="../assets/iconSinging.png"/>
    <Button text="下载小睡眠APP"></Button>
  </div>
</template>

<script>
// @ is an alias to /src
import Button from '../components/Button'

export default {
  name: 'home',
  data () {
    return {
      home_height: 0
    }
  },
  components: {
    Button
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  .home {
    flex-direction: column;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    width: px2html(375px);
  }
  .icon-singing {
    width: 140px;
    margin-bottom: 14px;
  }
</style>
